import { filterNilValue, QueryEntity } from "@datorama/akita";
import { PaloggetBrukerRepresentererTo } from "@husbanken/bruker-api";
import { UserRepresentsState, UserRepresentsStore } from "../stores/user-represents.store";
import { combineLatest, distinctUntilChanged, map, Observable, shareReplay } from "rxjs";
import { Realm, Representation as HeaderRepresentation } from "@husbanken/designsystem-angular-header-v2";
import { inject, Injectable } from "@angular/core";
import { UserQuery } from "./user.query";

@Injectable({ providedIn: "root" })
export class UserRepresentsQuery extends QueryEntity<UserRepresentsState, PaloggetBrukerRepresentererTo> {
  public headerRepresentation$: Observable<HeaderRepresentation>;
  public headerRepresentationList$: Observable<HeaderRepresentation[]>;
  private userQuery = inject(UserQuery);

  constructor() {
    super(inject(UserRepresentsStore));

    const urlRealm = window.location.pathname.split('/').filter(segment => segment !== '')[0];
    const proffRealm = 'proff';
    const privatRealm = 'privat';

    if (urlRealm === proffRealm) {
      this.headerRepresentation$ = combineLatest([this.selectActive(), this.userQuery.select(state => state.realm)]).pipe(
        map(([representation, realm]) => ({
          navn: representation?.organisasjonsnavn,
          fodselOrgIdNr: representation?.organisasjonsnummer,
          type: mapRealm(realm),
        })),
        filterNilValue(),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      this.headerRepresentationList$ = combineLatest([this.selectAll(), this.userQuery.select(state => state)]).pipe(
        map(([representations, user]) =>
          representations.map(representation => ({
            navn: representation?.organisasjonsnavn ?? user?.organization_name ?? user?.name,
            fodselOrgIdNr: representation?.organisasjonsnummer ?? user?.organization_number ?? user?.pid,
            type: mapRealm(user?.realm),
          })),
        ),
        filterNilValue(),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );
    }
  }
}

export function mapRealm(realm: string): Realm {
  switch (realm) {
    case "partner":
      return Realm.PARTNER;
    case "ansattporten":
    case "proff-niva4":
    case "proff":
      return Realm.PROFF;
    case "husbanken":
      return Realm.HUSBANKEN;
    case "privat":
      return Realm.PRIVATPERSON;
    default:
      throw new Error(`Ukjent realm: ${realm}`);
  }
}
